export function NotFoundPage() {
  return (
    <div className="flex flex-col items-center justify-center gap-4 p-8 text-center">
      <span className="text-7xl font-bold text-muted-foreground">404</span>
      <h1 className="text-2xl font-semibold text-foreground">Page not found</h1>
      <p className="text-muted-foreground">
        The page you are looking for does not exist or has been moved.
      </p>
    </div>
  );
}
